import React, { useEffect, useState } from "react"
 import {  Col } from "reactstrap"
 import Select from "react-select"; 

const SelectOptions = ({ Service ,options,setFormState, setOptions,validate, selected,id,label,...otherProps}) => {
    const service = new Service()
    const [submited, setSubmited] = useState(false)
    const [value, setValue] = useState(null)
    const [error, setError] = useState(false)

    useEffect(() => {
        setSubmited(validate)
    }, [validate])

    useEffect(() => {
        setValue(selected)
    }, [selected])
    useEffect(() => {
        if (submited) {
            setError(true)
        }
    }, [submited])
    
    useEffect(() => {
        const element=document.querySelector(`#${id}`)
        const firstChild=element.firstChild
        const lastChildElement=firstChild.lastChild
        const verticalSpan=lastChildElement.firstChild
        const icon=lastChildElement.lastChild
        firstChild.style.border="none"

        element.style.borderRadius=".3rem"
        if (error) {
            element.style.border="1px solid #f46a6a"
        //    verticalSpan.style.background="#f46a6a !important"
        //    icon.style.color="#f46a6a !important"
        //    lastChildElement.classList.remove("icon-container")
        //    lastChildElement.classList.add("icon-container2")
        }else{
              element.style.border="1px solid #cccccc"
            //   lastChildElement.classList.remove("icon-container2")
            //   lastChildElement.classList.add("icon-container")
            //   verticalSpan.style.background="#cccccc"
            //   icon.style.color="#cccccc"

        }
    }, [error])

    useEffect(() => {
        service.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ?item.name.en :item.name,
                    value: item.id
                }
            })
            setOptions(newOptions)
        })
    }, [])

    return (
        <Col md={6} className='mt-2' >
                <label style={{color: error ?"#f46a6a" :"#495057"}}>{label}</label>
                 <Select
                 id={id}
                    placeholder='Select'
                    className='mb-1'
                     options={options}
                    onChange={data => {
                        setFormState(data)
                        setError(false)
                    }}
                    value={value}
                    setOptions={options => setOptions(options)}
                    {...otherProps}
                /> 
               {error ? <span className="font-size-10 mt-0 " style={{color:"#f46a6a"}}>This field is Required</span> :null}
            </Col>
     )
}

export default SelectOptions